<script lang="ts">
	import heroImage3Xl from "@assets/images/about.jpg?webp&imagetools";
	import heroImageXs from "@assets/images/about.jpg?webp&w=960&h=1000&imagetools";
	import heroImageSm from "@assets/images/about.jpg?webp&w=1280h=1000&&imagetools";
	import heroImageMd from "@assets/images/about.jpg?webp&w=1600&imagetools";
	import heroImageLg from "@assets/images/about.jpg?webp&w=1920&imagetools";
	import heroImageXl from "@assets/images/about.jpg?webp&w=1920&imagetools";
	import heroImage2Xl from "@assets/images/about.jpg?webp&w=2400&imagetools";
	import fathersImage3Xl from "@assets/images/fathers-family-store.jpg?webp&imagetools";
	import fathersImageXs from "@assets/images/fathers-family-store.jpg?webp&w=800&imagetools";
	import fathersImageSm from "@assets/images/fathers-family-store.jpg?webp&w=960&imagetools";
	import fathersImageMd from "@assets/images/fathers-family-store.jpg?webp&w=1280&imagetools";
	import fathersImageLg from "@assets/images/fathers-family-store.jpg?webp&w=1600&imagetools";
	import fathersImageXl from "@assets/images/fathers-family-store.jpg?webp&w=1920&imagetools";
	import fathersImage2Xl from "@assets/images/fathers-family-store.jpg?webp&w=2400&imagetools";
	import fathersFamilyLogo from "@assets/images/fathers-family-written.png?webp&w=403&imagetools";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { getMembershipPagePath } from "@core/schema/paths/getMembershipPagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./FathersFamilyJoinUs.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<div class="grid lg:!grid-cols-2 full-width">
	<ImageSection
		class="lg:!col-span-1 w-full !h-[75vh]"
		sources={{
			default: fathersImageXs,
			">sm": fathersImageSm,
			">md": fathersImageMd,
			">lg": fathersImageLg,
			">xl": fathersImageXl,
			">2xl": fathersImage2Xl,
			">3xl": fathersImage3Xl,
		}}
		media="object-[50%_8.75%]"
		darkOverlay={false}
	>
		{#snippet heading()}
			<Heading level={2} text={translate("fathersFamily")}>
				<Media
					width={403}
					height={278}
					sourcesets={{}}
					source={{ type: "image/webp", src: fathersFamilyLogo }}
					alt=""
				/>
			</Heading>
		{/snippet}
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getMembershipPagePath(tenant)}>
				<Formatted text={translate("fathersFamilyMore")} />
			</Link>
		{/snippet}
	</ImageSection>
	<ImageSection
		class="lg:!col-span-1 w-full !h-[75vh]"
		sources={{
			default: heroImageXs,
			">sm": heroImageSm,
			">md": heroImageMd,
			">lg": heroImageLg,
			">xl": heroImageXl,
			">2xl": heroImage2Xl,
			">3xl": heroImage3Xl,
		}}
		heading={{ text: translate("aboutUs"), level: 2 }}
		paragraph={translate("whoWeAre")}
		darkOverlay={false}
	>
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getMembershipPagePath(tenant)}>
				<Formatted text={translate("aboutUsMore")} />
			</Link>
		{/snippet}
	</ImageSection>
</div>
